
export const PHONE_MASK = { mask: '+00000000000000' };
export const IBAN_PATTERN = '^([a-zA-Z]{2}[ \-]?[0-9]{2})(?=(?:[ \-]?[a-zA-Z0-9]){9,30}$)((?:[ \-]?[a-zA-Z0-9]{3,5}){2,7})([ \-]?[a-zA-Z0-9]{1,3})?$';


declare global {
  interface Number {
    formatMoney(): string;
    formatMoneyEuro(): string;
    formatMoneyCcy(currencyCode: number): string;
    formatMoneyWithPlusEuro(): string;
    formatMoneyWithPlusCcy(currencyCode: number): string;
    formatThousands(): string;
  }
}

Number.prototype.formatMoney = function(): string {
  return this.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

Number.prototype.formatMoneyEuro = function(): string {
  if (Number.isNaN(this)) {
    return null;
  }
  return '€ ' + this.formatMoney();
};

Number.prototype.formatMoneyCcy = function(currencyCode: number): string {
  if (Number.isNaN(this)) {
    return null;
  }
  let currencySymbol = '??';
  if ( currencyCode == 978) {
    currencySymbol = '€';
  } else if ( currencyCode == 578) {
    currencySymbol = 'NOK';
 }

  return currencySymbol + ' ' + this.formatMoney();
};

Number.prototype.formatMoneyWithPlusEuro = function(): string {
  if (Number.isNaN(this)) {
    return null;
  }
  return '€ ' + (this > 0 ? '+' : '') + this.formatMoney();
};

Number.prototype.formatMoneyWithPlusCcy = function(currencyCode: number): string {
  if (Number.isNaN(this)) {
    return null;
  }

  let currencySymbol = '??';
  if ( currencyCode == 978) {
    currencySymbol = '€';
  } else if ( currencyCode == 578) {
    currencySymbol = 'NOK';
  }

  return currencySymbol + ' ' + (this > 0 ? '+' : '') + this.formatMoney();
};

Number.prototype.formatThousands = function(): string {
  if (Number.isNaN(this)) {
    return null;
  }
  return Intl.NumberFormat('en').format(Number(this));
};
